import { render, staticRenderFns } from "./ReportModalFooter.vue?vue&type=template&id=0fff24e6&"
import script from "./ReportModalFooter.vue?vue&type=script&lang=js&"
export * from "./ReportModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports